
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';
import { getResource } from '../../../../../framework/client/resource';
import { VendorContractType } from '../../../../../../common/application/model/enums/VendorContractType';
import { VendorContract } from '../../../../../../common/application/model/VendorContract';
import { getEnumerationOptions, getOptionLabel } from '../../../../../framework/service/options';
import {
    getAccountOptions,
    getCustomerOptions,
    getVendorLocationOptions,
    getVendorOptions,
} from '../../../../service/application_options_service';
import { VendorContractScope } from '../../../../../../common/application/model/enums/VendorContractScope';
import { PaymentType } from '../../../../../../common/application/model/enums/PaymentType';
import { BudgetType } from '../../../../../../common/application/model/enums/BudgetType';
import { AccountType } from '../../../../../../common/application/model/enums/AccountType';
import { VehicleContract } from '../../../../../../common/application/model/VehicleContract';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import ViewDocuments from '../../document/ViewDocuments.vue';
import { formatToFinnishDate } from '../../../../../application/service/helper_service';

@Component({
    components: {
        ViewDocuments,
    },
    beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: ViewVendorContract) => {
            vm.getPrevRouter(from); //get the previous URL
        });
    },
})
export default class ViewVendorContract extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VENDOR_CONTRACT;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as VendorContract,
        customerOptions: [] as { id: string | undefined; label: string }[],
        vendorOptions: [] as { id: string | undefined; label: string }[],
        vehicleContract: {} as VehicleContract | undefined,
        vendorContractTypeOptions: [] as { id: string | undefined; label: string }[],
        vendorContractScopeOptions: [] as { id: string | undefined; label: string }[],
        vendor: '',
        paymentTypeOptions: [] as { id: string | undefined; label: string }[],
        budgetTypeOptions: [] as { id: string | undefined; label: string }[],
        customerExpenseAccountOptions: [] as { id: string | undefined; label: string }[],
        vendorLocationOptions: [] as { id: string | undefined; label: string }[],
        customer: '',
        vendorContractType: '',
        vendorContractScope: '',
        paymentType: '',
        budgetType: '',
        customerExpenseAccount: '',
        vendorLocation: '',
        activeTab: 0,
        prevRoute: '',
    };

    // Functions
    async mounted() {
        this.local.activeTab = Number(localStorage.getItem(`${this.resourceType}_ActiveTab`));
        this.local.customerOptions = await getCustomerOptions();
        this.local.vendorOptions = await getVendorOptions();
        this.local.vendorContractTypeOptions = getEnumerationOptions(
            'VendorContractType',
            Object.keys(VendorContractType),
            this,
        );
        this.local.vendorContractScopeOptions = getEnumerationOptions(
            'VendorContractScope',
            Object.keys(VendorContractScope),
            this,
        );
        this.local.paymentTypeOptions = getEnumerationOptions('PaymentType', Object.keys(PaymentType), this);
        this.local.budgetTypeOptions = getEnumerationOptions('BudgetType', Object.keys(BudgetType), this);
        this.local.vendorLocationOptions = await getVendorLocationOptions();

        this.local.row = (await getResource<VendorContract>(this.resourceType, this.id))!!;

        this.local.vehicleContract = await getResource<VehicleContract>(
            ApplicationResource.VEHICLE_CONTRACT,
            this.local.row.vehicleContractId,
        );

        this.local.customer = getOptionLabel(this.local.row.customerId, this.local.customerOptions);
        this.local.vendor = getOptionLabel(this.local.row.vendorId, this.local.vendorOptions);
        this.local.vendorContractType = getOptionLabel(
            this.local.row.vendorContractType,
            this.local.vendorContractTypeOptions,
        );
        this.local.vendorContractScope = getOptionLabel(
            this.local.row.vendorContractScope,
            this.local.vendorContractScopeOptions,
        );
        this.local.paymentType = getOptionLabel(this.local.row.paymentType, this.local.paymentTypeOptions);
        this.local.budgetType = getOptionLabel(this.local.row.budgetType, this.local.budgetTypeOptions);
        this.local.vendorLocation = getOptionLabel(this.local.row.vendorLocationId, this.local.vendorLocationOptions);

        if (this.isAdmin) {
            this.local.customerExpenseAccountOptions = await getAccountOptions(
                this.local.row.customerId,
                AccountType.EXPENSE,
            );

            if (this.local.row.customerExpenseAccountId) {
                this.local.customerExpenseAccount = getOptionLabel(
                    this.local.row.customerExpenseAccountId,
                    this.local.customerExpenseAccountOptions,
                );
            }
        }
        localStorage.removeItem(`${this.resourceType}_ActiveTab`);
    }

    back() {
        this.$router.go(-1);
    }

    edit() {
        this.$router.push(`/vendor-contract/${this.local.row.id}/edit`);
    }

    addDocument() {
        this.$router.push({ name: 'EditVendorContract', params: { activeTab: this.local.activeTab } } as any);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    getPrevRouter(from: any) {
        this.local.prevRoute = from.path;
        if (this.local.prevRoute.includes('/file-meta/')) {
            this.local.activeTab = 1;
        }
    }

    getActiveTab(value: number) {
        localStorage.setItem(`${this.resourceType}_ActiveTab`, JSON.stringify(value));
    }

    formatDate(date: Date | null): string {
        return formatToFinnishDate(date ? date.toString() : null);
    }
}
